import { Form } from 'antd';
import { StyledFormErrorList } from './FormListErrorStyles';
const { ErrorList } = Form;

export type IFormListErrorProps = React.ComponentProps<typeof ErrorList>;

const FormListError = (props: IFormListErrorProps): JSX.Element => <StyledFormErrorList {...props} />;

export default FormListError;
